export default __webpack_public_path__ + "static/media/upworkFeedback1.d56598ee.png";